import type { ReactNode } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'

export type StatusNavPhaseState = 'done' | 'current' | 'upcoming'

export const StatusNavItem = ({
  label,
  phaseState,
  selected,
  subLabel,
  icon,
  onClick,
}: {
  label: string
  phaseState: StatusNavPhaseState
  selected: boolean
  subLabel: string
  icon?: ReactNode
  onClick: () => void
}) => {
  const isDone = phaseState === 'done'
  const isCurrent = phaseState === 'current'

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${label}: ${subLabel}`}
      aria-current={selected ? 'page' : undefined}
      className={cn(
        'relative flex min-w-0 items-center gap-1.5 rounded-2xl px-2 py-1.5 transition-colors active:scale-[0.98] sm:gap-2.5 sm:px-2.5 sm:py-2',
        selected && 'bg-gray-100/80',
        !selected && 'hover:bg-black/[0.03]'
      )}
    >
      <div
        className={cn(
          'relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full sm:h-9 sm:w-9',
          isDone && 'bg-emerald-100 text-emerald-700',
          isCurrent && 'border border-orange-300 bg-orange-50 text-orange-500',
          phaseState === 'upcoming' &&
            'border border-gray-200 bg-white text-muted-foreground/70'
        )}
      >
        {icon}
      </div>

      <Column className="min-w-0 gap-1 text-left">
        <span className="truncate text-[13px] font-medium leading-none tracking-tight text-foreground">
          {label}
        </span>
        <span
          className={cn(
            'hidden truncate text-[11px] font-normal leading-none sm:block',
            isDone && 'text-emerald-700',
            isCurrent && 'text-orange-600',
            phaseState === 'upcoming' && 'text-muted-foreground'
          )}
        >
          {subLabel}
        </span>
      </Column>
    </button>
  )
}
